__turbopack_context__.v({
  "icon": "InscriptionActionView-module__87Ygnq__icon",
});
